import { env } from '@/config/env';

/**
 * Resolves an image URL from the backend.
 * If the URL is relative (e.g. /uploads/avatars/xxx.png), prepends the API base URL.
 * If it's already absolute or a blob URL, returns as-is.
 */
export function resolveImageUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  if (url.startsWith('blob:') || url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  return `${env.API_BASE_URL}${url}`;
}
